import { z } from 'zod';

export const markdownSenderTypeParser = z.preprocess(
  (val: unknown) => {
    switch (val) {
      case 'TEMPLATE':
        return 'TEMPLATE';
      case 'VERIFIED_EMAIL_ADDRESS':
      default:
        return 'VERIFIED_EMAIL_ADDRESS';
    }
  },
  z.enum(['VERIFIED_EMAIL_ADDRESS', 'TEMPLATE'] as const)
);
